import React from "react";
import { useNavigate } from "react-router-dom";
import { DestinationsData } from "../../utils/destinations";
import sonmargImg from "../../assets/images/epic-banner.jpg";
const Destinations = () => {
  const navigate = useNavigate();

  const handleDestinationClick = (dest: string) => {
    navigate(`/pages/Destinations/${dest}`);
  };

  return (
    <div className="bg-black">
      {/* Hero Section */}
      <div className="relative w-full h-[200px] lg:h-[400px]">
        <img
          src={sonmargImg}
          alt="Banner"
          className="object-cover w-full h-full"
        />
        <div className="absolute inset-0 flex items-center justify-center px-4">
          {/* <img
            src={about}
            alt="Banner"
            className="object-cover max-w-[20%] max-h-[30%]"
          /> */}
        </div>
      </div>

      <div className="container mt-20">
        <div className="lg:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10 items-center justify-center hidden">
          {DestinationsData?.map((dest, index) => (
            <div
              key={index}
              className="relative group flex items-center flex-shrink-0 text-center border border-gray-700 p-5 lg:mx-0 md:mx-0 mx-5 rounded-lg gap-10 transition transform hover:-translate-y-2 hover:shadow-muted-500 shadow-lg cursor-pointer"
              onClick={() => handleDestinationClick(dest.slug)}
            >
              <div className="w-28 h-28 overflow-hidden rounded-full border-2 border-gray-300">
                <img
                  src={dest.image.src}
                  alt={dest.image.alt}
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="mt-2 text-sm font-medium">{dest.title}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10 items-center justify-center lg:hidden px-4">
          {DestinationsData.map((dest, index) => (
            <div
              key={index}
              className="relative group flex flex-col items-center flex-shrink-0 text-center border border-gray-700 p-5 rounded-lg gap-4 transition transform hover:-translate-y-2 hover:shadow-muted-500 shadow-lg cursor-pointer"
              onClick={() => handleDestinationClick(dest.slug)}
            >
              <div className="w-28 h-28 overflow-hidden rounded-full border-2 border-gray-300">
                <img
                  src={dest.image.src}
                  alt={dest.image.alt}
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="mt-2 text-sm font-medium">{dest.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Destinations;
